import { render } from "./GeneralAgreement.vue?vue&type=template&id=77160574&ts=true"
import script from "./GeneralAgreement.vue?vue&type=script&lang=ts"
export * from "./GeneralAgreement.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/l333n/Development/lennarthakker/lennarthakker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__